(() => {
  const initialiseRoomVisuals = (root = document) => {
    root.querySelectorAll?.('[data-pu-room-visual]').forEach((visual) => {
      if (visual.dataset.puRoomReady === 'true') return;
      visual.dataset.puRoomReady = 'true';

      const hotspots = [...visual.querySelectorAll('[data-pu-room-hotspot]')];
      const panels = [...visual.querySelectorAll('[data-pu-room-panel]')];
      const hint = visual.querySelector('[data-pu-room-hint]');
      let activeIndex = null;

      const markInteracted = () => {
        if (visual.dataset.puRoomInteracted === 'true') return;
        visual.dataset.puRoomInteracted = 'true';
        if (hint) hint.hidden = true;
      };

      const close = ({ returnFocus = false } = {}) => {
        if (activeIndex === null) return;
        const previousIndex = activeIndex;
        activeIndex = null;
        hotspots.forEach((hotspot) => hotspot.setAttribute('aria-expanded', 'false'));
        panels.forEach((panel) => { panel.hidden = true; });
        if (returnFocus) hotspots[previousIndex]?.focus();
      };

      const open = (index) => {
        activeIndex = index;
        hotspots.forEach((hotspot, hotspotIndex) => {
          hotspot.setAttribute('aria-expanded', hotspotIndex === index ? 'true' : 'false');
        });
        panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
      };

      hotspots.forEach((hotspot, index) => {
        hotspot.addEventListener('click', () => {
          markInteracted();
          if (activeIndex === index) close();
          else open(index);
        });
      });

      panels.forEach((panel) => {
        panel.querySelector('[data-pu-room-close]')?.addEventListener('click', () => {
          close({ returnFocus: true });
        });
      });

      visual.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || activeIndex === null) return;
        event.preventDefault();
        close({ returnFocus: true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseRoomVisuals(), { once: true });
  } else {
    initialiseRoomVisuals();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseRoomVisuals(event.target));
})();
